import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { apprOf } from "../lib/appearance";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Problem from "../components/site/Problem";
import Regulatorik from "../components/site/Regulatorik";
import Zielgruppen from "../components/site/Zielgruppen";
import Leistungen from "../components/site/Leistungen";
import Ablauf from "../components/site/Ablauf";
import About from "../components/site/About";
import Partners from "../components/site/Partners";
import PartnerVoices from "../components/site/PartnerVoices";
import Testimonials from "../components/site/Testimonials";
import Faq from "../components/site/Faq";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import FloatingCall from "../components/site/FloatingCall";
import LinkedInFeed from "../components/site/LinkedInFeed";

const DEFAULT_ORDER = ["zielgruppen", "leistungen", "problem", "ablauf", "inhaber", "partner", "regulatorik", "partnerstimmen", "kundenstimmen", "kontakt", "faq", "linkedin"];

export default function Landing() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="animate-pulse font-head font-bold text-2xl text-[var(--mf-grey)]">MF MED</div>
      </div>
    );
  }

  const s = data.settings || {};
  const heroAppr = apprOf(s, "hero");
  const registry = {
    zielgruppen: (i) => <Zielgruppen key="zielgruppen" index={i} items={data.zielgruppen} appr={apprOf(s, "zielgruppen")} />,
    leistungen: (i) => <Leistungen key="leistungen" index={i} items={data.leistungen} appr={apprOf(s, "leistungen")} />,
    regulatorik: (i) => <Regulatorik key="regulatorik" index={i} data={s.regulatorik} appr={apprOf(s, "regulatorik")} />,
    problem: (i) => <Problem key="problem" index={i} problems={s.problems} appr={apprOf(s, "problem")} />,
    ablauf: (i) => <Ablauf key="ablauf" index={i} steps={s.process} appr={apprOf(s, "ablauf")} />,
    inhaber: (i) => <About key="inhaber" index={i} about={s.about} appr={apprOf(s, "inhaber")} />,
    partner: (i) => <Partners key="partner" index={i} partners={s.partners} appr={apprOf(s, "partner")} />,
    partnerstimmen: (i) => <PartnerVoices key="partnerstimmen" index={i} items={data.partner_voices} appr={apprOf(s, "partnerstimmen")} />,
    kundenstimmen: (i) => <Testimonials key="kundenstimmen" index={i} items={data.testimonials} appr={apprOf(s, "kundenstimmen")} />,
    kontakt: (i) => <Contact key="kontakt" index={i} contact={s.contact} emailTemplate={s.email_template} appr={apprOf(s, "kontakt")} />,
    faq: (i) => <Faq key="faq" index={i} faq={s.faq} appr={apprOf(s, "faq")} />,
    linkedin: (i) => <LinkedInFeed key="linkedin" index={i} posts={s.linkedin_posts} profile={s.about?.linkedin} />,
  };
  const saved = s.section_order && s.section_order.length ? s.section_order : DEFAULT_ORDER;
  const order = [...saved, ...Object.keys(registry).filter((k) => !saved.includes(k))].filter((k) => registry[k]);

  return (
    <div className="bg-white">
      <div aria-hidden="true" data-testid="left-red-rail" className="fixed inset-0 z-[55] pointer-events-none">
        <div className="mf-container relative h-full">
          <div data-testid="left-red-rail-line" className="absolute inset-y-0 left-6 lg:left-10 w-[2px] bg-[var(--mf-red)]" />
        </div>
      </div>
      <Header contact={s.contact} logoHeight={s.logo_height} logoHeightMobile={s.logo_height_mobile} bgColor={heroAppr.bg} dark={heroAppr.dark} />
      <main>
        <Hero hero={s.hero} contact={s.contact} appr={apprOf(s, "hero")} />
        {order.map((key, idx) => registry[key](String(idx + 1).padStart(2, "0")))}
      </main>
      <Footer contact={s.contact} />
      <FloatingCall contact={s.contact} />
    </div>
  );
}
